import { isoZ, z } from 'my-zod'
import { enumOptionsToObject } from '../../internal'

export const messageTemplateStatusOptions = ['Draft', 'Live', 'Archived'] as const
export const messageTemplateStatuses = enumOptionsToObject(messageTemplateStatusOptions)

export type MessageTemplateStatus = (typeof messageTemplateStatusOptions)[number]

export const outfitterMessageTemplateModel = z.object({
  id: z.string().uuid(),
  outfitterId: z.number().int(),
  name: z.string().min(1, 'Required').max(100),
  emailTemplate: z.string().max(3000).nullable(),
  smsTemplate: z.string().max(500).nullable(),
  status: z.enum(messageTemplateStatusOptions),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type outfitterMessageTemplateModel = z.infer<typeof outfitterMessageTemplateModel>
